import React, { ComponentType } from 'react';
import FetchComponent from '../../../components/behavior/FetchComponent';
import { Spinner } from '../../../components/Spinner';
import { ContentType } from '../../../provider/Typo3Provider/types';
import { BusOffersContainerProps } from '../../BusOffersContainer';
import { BustypeSelectContainerProps } from '../../BustypeSelectContainer';
import { FormSellContainerProps } from '../../FormSellContainer';
import { GridTeaserContainerProps } from '../../GridTeaserContainer';
import { CountryContainerProps } from '../../LandingPages/CountryContainer';
import { ManufacturerContainerProps } from '../../LandingPages/ManufacturerContainer';
import { MagazineTeaserContainerProps } from '../../MagazineTeaserContainer';
import { MapContainerProps } from '../../MapContainer';
import { SearchDetailProps } from '../../SearchContainer/SearchDetail';
import { SearchResultProps } from '../../SearchContainer/SearchResult';
import { WatchlistContainerProps } from '../../WatchlistContainer';
import { Grid10YearsProps } from '../../Grid10YearsContainer';
import CallToActionButton from './CallToActionButton';
import CallToActionContainer from './CallToActionContainer';
import DividerContainer from './DividerContainer';
import FormContact from './FormContactContainer';
import { FormEventRegistrationContainerProps } from './FormEventRegistrationContainer';
import HeaderContainer from './HeaderContainer';
import HtmlContainer from './HtmlContainer';
import FullVideo from './mappingHelper/FullVideo';
import { ImageContent, ImageFull, TwoImages } from './mappingHelper/Images';
import { TeaserCircle, TeaserSquare } from './mappingHelper/Teasers';
import {
  Text,
  TextPicLeft33,
  TextPicLeft50,
  TextPicRight33,
  TextPicRight50,
  TextVideoLeft50,
  TextVideoRight50
} from './mappingHelper/Text';
import { NewsletterContainerProps } from './NewsletterFormContainer';
import SitemapContainer from './SitemapContainer';
import UsercentricsPrivacy from './UsercentricsPrivacy';
import NewsletterTeaserContainer from './NewsletterTeaserContainer';

const AsyncBusOffersContainer = (props: BusOffersContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../BusOffersContainer' /* webpackChunkName: "bus-offers-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

// TODO: Add nice placeholder. This is a bit hacky to prevent a CLS when loading the startpage.
const AsyncBustypeSelectContainer = (props: BustypeSelectContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../BustypeSelectContainer' /* webpackChunkName: "bustype-select-container", webpackPrefetch: true */)
    }
    placeholder={<div style={{height: '400px'}}></div>}
    props={props}
    delayMs={0}
  />
);

const AsyncGridTeaserContainer = (props: GridTeaserContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../GridTeaserContainer' /* webpackChunkName: "grid-teaser-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncMagazinSliderContainer = (props: GridTeaserContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../GridTeaserContainer/MagazineSlider' /* webpackChunkName: "magazine-slider", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncMapContainer = (props: MapContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../MapContainer' /* webpackChunkName: "map-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncSearchDetail = (props: SearchDetailProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../SearchContainer/SearchDetail' /* webpackChunkName: "search-detail", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncCountryContainer = (props: CountryContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../LandingPages/CountryContainer' /* webpackChunkName: "country-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncManufacturerContainer = (props: ManufacturerContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../LandingPages/ManufacturerContainer' /* webpackChunkName: "manufacturer-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncSearchResult = (props: SearchResultProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../SearchContainer/SearchResult' /* webpackChunkName: "search-result", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncWatchlistContainer = (props: WatchlistContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../WatchlistContainer' /* webpackChunkName: "watchlist-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncNewsletterForm = (props: NewsletterContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('./NewsletterFormContainer' /* webpackChunkName: "newsletter-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncFormEventRegistrationContainer = (
  props: FormEventRegistrationContainerProps
) => (
  <FetchComponent
    fetcher={() =>
      import('./FormEventRegistrationContainer' /* webpackChunkName: "form-event-registration-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncFormSellContainer = (props: FormSellContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../FormSellContainer' /* webpackChunkName: "form-sell-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncMagazineTeaserContainer = (props: MagazineTeaserContainerProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../MagazineTeaserContainer' /* webpackChunkName: "magazine-teaser-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncGrid10Years = (props: Grid10YearsProps) => (
  <FetchComponent
    fetcher={() =>
      import('../../Grid10YearsContainer' /* webpackChunkName: "grid-10-years", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

const AsyncVideoTeaserContainer = (props: any) => (
  <FetchComponent
    fetcher={() =>
      import('../../VideoTeaserContainer' /* webpackChunkName: "video-teaser-container", webpackPrefetch: true */)
    }
    placeholder={<Spinner />}
    props={props}
  />
);

export const contentComponents: { [key in ContentType]: ComponentType<any> } = {
  busoffers: AsyncBusOffersContainer,
  bustypeselect: AsyncBustypeSelectContainer,
  calltoaction: CallToActionContainer,
  calltoaction_button: CallToActionButton,
  div: DividerContainer,
  form_contact: FormContact,
  form_eventregistration: AsyncFormEventRegistrationContainer,
  form_sell: AsyncFormSellContainer,
  video_full: FullVideo,
  video_teaser: AsyncVideoTeaserContainer,
  grid_teaser: AsyncGridTeaserContainer,
  grid10years: AsyncGrid10Years, // Added for 10 years anniversary #59547
  header: HeaderContainer,
  html: HtmlContainer,
  image_content: ImageContent,
  image_full: ImageFull,
  magazine_overview: AsyncMagazineTeaserContainer,
  // handled in DataLayerContainer{,Mobile}, as it is used in `pathContent.layer`
  // where no component-mapping is in use
  menu_pages: () => null,
  newsletter_form: AsyncNewsletterForm,
  search: AsyncSearchResult,
  searchdetail: AsyncSearchDetail,
  searchlocation: AsyncCountryContainer,
  searchmanufacturer: AsyncManufacturerContainer,
  usercentrics_privacy: UsercentricsPrivacy,
  sitemap: SitemapContainer,
  // handled as Null-Component, as it is used in `pathContent.stage`
  // where no component-mapping is in use
  slider_pic: () => null,
  slider_textpic: () => null,
  teaser_circle: TeaserCircle,
  teaser_slider_magazine: AsyncMagazinSliderContainer,
  teaser_square: TeaserSquare,
  text: Text,
  textpic_left_33: TextPicLeft33,
  textpic_right_33: TextPicRight33,
  textpic_left_50: TextPicLeft50,
  textpic_right_50: TextPicRight50,
  textvideo_left_50: TextVideoLeft50,
  textvideo_right_50: TextVideoRight50,
  twoimages: TwoImages,
  usedvehiclecenter_map: AsyncMapContainer,
  watchlist: AsyncWatchlistContainer,
  ppi_newsletterteaser: NewsletterTeaserContainer,
};
